const items = [
  { text: 'Home', href: '/', end: true },
  { text: 'Movies', href: 'movies', end: false },
];

export default items;
